<div class="layout-rightpanel" (click)="app.onRightPanelClick()">
    <div class="rightpanel-wrapper">
        <div class="section-tasks today">
            <h5>Your Tasks Today</h5>
        </div>
    </div>
</div>
